"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.duration = exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _useIsomorphicLayoutEffect = _interopRequireDefault(require("../../utils/use-isomorphic-layout-effect"));
var _measureHiddenNode2 = _interopRequireDefault(require("../../utils/measure-hidden-node"));
var _useAnimationState = require("../../utils/use-animation-state");
require("./expander.css");
var _excluded = ["children", "isExpanded", "expandEffect"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var duration = exports.duration = 300;

/**
 * `Expander` animates the height of its children to an expanded
 * or collapsed state based on the value of the `isExpanded` prop.
 *
 * There are two effects for showing/hiding content as the Expander animates,
 * which are passed as props:
 * - `reveal` (default) -> Content is revealed top-down (ie. top is seen first)
 * - `pushdown` -> Content is pushed down into view (ie. bottom is seen first)
 *
 * Note: The `SimpleExpander` (see below) builds on top of `Expander`;
 * it provides out of the box logic for toggling the expanded state and handles
 * accessibility concerns.
 */
var Expander = function Expander(_ref) {
  var children = _ref.children,
    _ref$isExpanded = _ref.isExpanded,
    isExpanded = _ref$isExpanded === void 0 ? false : _ref$isExpanded,
    _ref$expandEffect = _ref.expandEffect,
    expandEffect = _ref$expandEffect === void 0 ? 'reveal' : _ref$expandEffect,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var containerRef = _react["default"].useRef();
  var contentRef = _react["default"].useRef();
  var animationState = (0, _useAnimationState.useAnimationState)(isExpanded, duration);
  var _useState = (0, _react.useState)(isExpanded ? 'auto' : '0px'),
    _useState2 = _slicedToArray(_useState, 2),
    height = _useState2[0],
    setHeight = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    prevAnimationState = _useState4[0],
    setPrevAnimationState = _useState4[1];
  var setHeightToContentHeight = function setHeightToContentHeight() {
    var _measureHiddenNode = (0, _measureHiddenNode2["default"])({
        node: contentRef.current,
        parentNode: containerRef.current
      }),
      contentHeight = _measureHiddenNode.height;
    setHeight("".concat(contentHeight, "px"));
  };
  (0, _useIsomorphicLayoutEffect["default"])(function () {
    if (animationState === _useAnimationState.states.opening) {
      setHeightToContentHeight();
    }
    if (animationState === _useAnimationState.states.open) {
      // setting to auto helps to ensure that the "final" height is correct,
      // and allow changes in viewport to effect reflow normally
      setHeight('auto');
    }
    if (animationState === _useAnimationState.states.closing) {
      // can't change straight from 'auto' to zero, because transition won't work.
      // So we first set the content height...
      setHeightToContentHeight();
    }
    // ... then re-set the height on the next state change
    if (prevAnimationState === _useAnimationState.states.closing) {
      setHeight('0px');
    }
    if (animationState !== prevAnimationState) {
      // Because there are two height changes needed to animate closed, but only one
      // animation state change, we track the previous animation state
      // to give us the extra render (which allows us to set the height twice).
      setPrevAnimationState(animationState);
    }
  }, [animationState, prevAnimationState]);
  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: (0, _classnames["default"])('sb-expander', {
      'position-relative': expandEffect === 'pushdown',
      'sb-expander_overflow': animationState !== _useAnimationState.states.open
    }),
    ref: containerRef,
    style: {
      height: height
    }
  }, otherProps), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])({
      hidden: animationState === _useAnimationState.states.closed,
      // once pushdown type is open, let it not be absolutely positioned, so
      // auto height works
      'sb-expander__pushdownContent': expandEffect === 'pushdown' && animationState !== _useAnimationState.states.open
    }),
    ref: contentRef
  }, children));
};
Expander.displayName = 'Expander';
Expander.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes["default"].node,
  /**
   * How the content appears as the expander animates open
   */
  expandEffect: _propTypes["default"].oneOf(['reveal', 'pushdown']),
  isExpanded: _propTypes["default"].bool.isRequired
} : {};
var _default = exports["default"] = Expander;